import { Component, OnInit, Inject } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import * as Tokens from '@shared/core/tokens';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-loyalty-for-promotion',
    templateUrl: './loyalty-for-promotion.shared.component.html',
    styleUrls: ['./loyalty-for-promotion.shared.component.scss']
})
export class LoyaltyForPromotionComponent implements OnInit {
    public loading$: Observable<boolean>;
    public promotionItems$: Observable<APICommon.IPromotionItem[]>;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public controllers: Controllers
    ) { }

    ngOnInit(): void {
        this.controllers.loyalty.checkForLoyaltyIntroductionPages();

        this.loading$ = this.controllers.loyalty.isLoadingLoyaltyIntroductionPages$();
        this.promotionItems$ = this.controllers.loyalty.loyaltyIntroductionPagesPromotionModel$();
    }

    public get layout(): 'row' | 'column' {
        return this.config.ui.loyalty.layout || 'row';
    }

}
